import { Identifiable, Project, ProjectConfiguration } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function projectConfigurationToString(config: ProjectConfiguration): string {
  const keysMap: { [Key in keyof ProjectConfiguration]: string } = {
    isSynthesisEnabled: "Synthesis",
    isListsListEnabled: "ListsList",
    isBoardEnabled: "Board",
    isGanttEnabled: "Gantt",
    areTimeSheetsEnabled: "TimeSheets",
    areDiscussionsEnabled: "Discussions",
    areDocumentsEnabled: "Documents",
    isBudgetEnabled: "Budget",
    isCalendarEnabled: "Calendar",
    areReportsEnabled: "Reports",
  };

  return Object.entries(config)
    .filter(([_, isEnabled]) => !isEnabled)
    .map(([key]) => keysMap[key as keyof typeof keysMap])
    .join(",");
}

function updateProjectConfiguration(httpClient: HttpClient) {
  return (project: Identifiable<Project>, config: ProjectConfiguration) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${project.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        attributes: {
          toolsConfig: projectConfigurationToString(config),
        },
      },
    });
}

export { updateProjectConfiguration };
